/**
 * The scroll area a lazily loaded picture is watched in (TMMAPP-0142 M9): the transcript's, or the
 * help panel's. `useLazyObjectUrl` passes it as the `IntersectionObserver` root, so its margin is
 * measured against what actually scrolls and a small scroll doesn't refetch. Null (the default)
 * watches against the viewport.
 */
import { createContext } from 'react';

export const LazyRootContext = createContext<Element | null>(null);
